export default "__VITE_ASSET__K0pThBNy__"